<template>
  <div class="full-height">
    <template v-if="type === 'color'">
      <div :class="`banner-item card-type-${type}`">
        <div
                :style="`background-color:${backgroundColor}`"
                class="color-background"
        />
        <div
                :class="`banner-text-${textAlign} banner-content-position-${verticalTextAlign}`"
                class="banner-content"
        >
          <b-container>
            <b-row>
              <b-col>
              <div class="banner-content-inner">
                <div class="banner-title">
                  <h1
                          :style="`color:${textColor}`"
                  >
                    {{ title }}
                  </h1>
                </div>
                <div
                        :style="`color:${textColor}`"
                        class="banner-description"
                >
                  {{ description }}
                </div>
                <div class="banner-action">
                  <template v-if="buttonPrimaryExists">
                    <generic-link
                            :target="primaryButtonTarget"
                            :href="buttonPrimaryUrl"
                            class="btn banner-btn banner-btn-primary"
                    >
                      {{ buttonPrimaryText }}
                    </generic-link>
                  </template>

                  <template v-if="buttonSecondaryExists">
                    <generic-link
                            :target="secondaryButtonTarget"
                            :href="buttonSecondaryUrl"
                            class="btn banner-btn banner-btn-secondary"
                    >
                      {{ buttonSecondaryText }}
                    </generic-link>
                  </template>
                </div>
                </div>
              </b-col>
            </b-row>
          </b-container>
        </div>
      </div>
    </template>

    <template v-else-if="type === 'photo'">
      <div :class="`banner-item card-type-${type}`">
        <div
                class="image-background"
        >
          <AImage
                  :img="item.fileStore"
                  :title="title"
                  :alt="title"
                  responsive
                  preset="carousel-image"
          />
        </div>

        <div
                :style="`opacity:${backgroundTinting}`"
                class="image-overlay"
        />
        <div
                v-if="description || title || buttonPrimaryExists || buttonSecondaryExists"
                :class="`banner-text-${textAlign} banner-content-position-${verticalTextAlign}`"
                class="banner-content banner-content-gradient"
        >
          <b-container>
            <b-row>
              <b-col

              >
              <div class="banner-content-inner">
                  <div class="banner-title">
                    <h1>{{ title }}</h1>
                  </div>
                  <div
                          v-if="description"
                          class="banner-description"
                  >
                    {{ description }}
                  </div>
                  <div
                          v-if="buttonPrimaryExists || buttonSecondaryExists"
                          class="banner-action"
                  >
                    <template v-if="buttonPrimaryExists">
                      <generic-link
                              :target="primaryButtonTarget"
                              :href="buttonPrimaryUrl"
                              class="btn banner-btn banner-btn-primary"
                      >
                        {{ buttonPrimaryText }}
                      </generic-link>
                    </template>

                    <template v-if="buttonSecondaryExists">
                      <generic-link
                              :target="secondaryButtonTarget"
                              :href="buttonSecondaryUrl"
                              class="btn banner-btn banner-btn-secondary"
                      >
                        {{ buttonSecondaryText }}
                      </generic-link>
                    </template>
                  </div>
                </div>
              </b-col>
            </b-row>
          </b-container>
        </div>
        <template v-else-if="buttonPrimaryUrl">
          <generic-link
                  :target="primaryButtonTarget"
                  :href="buttonPrimaryUrl"
                  class="banner-overlay-link"
          />
        </template>
      </div>
    </template>

    <template v-else-if="type === 'video'">
      <div :class="`banner-item card-type-${type}`">
        <iframe
                :src="`${videoUrl}?rel=0&amp;controls=0&amp;showinfo=0`"
                width="100%"
                frameborder="0"
                allow="autoplay; encrypted-media"
                allowfullscreen
        />
      </div>
    </template>

    <template v-else-if="type == 'wysiwyg'">
      <div :class="`banner-item card-type-${type}`">
        <div v-html="description" />
      </div>
    </template>

    <!-- Icon Card -->
    <template v-else-if="type === 'icon'">
      <div
              :style="`background-color: ${backgroundColor}`"
              :class="[`col-item card card-${type} card-text-${textAlign}`, {'card-text-center': iconPosition === 'center' }]"
      >
        <div class="card-content-body">
          <template v-if="iconPosition === 'left'">
            <div class="icon-header">
              <div class="icon-container">
                <!--<img-->
                        <!--:src="backgroundImageUrl"-->
                        <!--:class="{'drop-shadow': iconDropShadow === true }"-->
                        <!--class="svg-icon"-->
                        <!--alt="Icon"-->
                <!--&gt;-->
                <AImage
                  :img="item.fileStore"
                  :title="title"
                  :alt="title"
                  :class="{'drop-shadow': iconDropShadow === true }"
                  class="svg-icon"
                  responsive
                  preset="carousel-image"
                />
              </div>
              <div class="title">
                <h3 :style="`color: ${textColor}`">
                  {{ title }}
                </h3>
              </div>
            </div>
            <div
              v-if="description"
              :style="`color: ${textColor}`"
              class="description"
            >
            {{ description }}
          </div>
          </template>
          <template v-if="iconPosition === 'leftcontent'">
              <div class="icon-container">
                <img
                        :src="backgroundImageUrl"
                        :class="{'drop-shadow': iconDropShadow === true }"
                        class="svg-icon"
                        alt="Icon"
                >
              </div>
              <div class="icon-content">
                <div class="title">
                  <h3 :style="`color: ${textColor}`">
                    {{ title }}
                  </h3>
                </div>
                <div
                    v-if="description"
                    :style="`color: ${textColor}`"
                    class="description"
                >
                  {{ description }}
                </div>
              </div>
          </template>
          <template v-if="iconPosition === 'left'">
            <div class="icon-container text-center">
              <img
                      :src="backgroundImageUrl"
                      :class="{ 'drop-shadow': iconDropShadow === true }"
                      class="svg-icon"
                      alt="Icon"
              >
            </div>
            <div class="title">
              <h3 :style="`color: ${textColor}`">
                {{ title }}
              </h3>
            </div>
          <div
                  v-if="description"
                  :style="`color: ${textColor}`"
                  class="description"
          >
            {{ description }}
          </div>
          </template>

        </div>
        <template
                v-if="buttonPrimaryExists && buttonSecondaryExists"
        >
          <div class="card-content-footer">
            <div
                    v-if="buttonPrimaryExists && buttonSecondaryExists"
                    class="card-actions"
            >
              <template v-if="buttonPrimaryExists">
                <generic-link
                        :target="primaryButtonTarget"
                        :href="buttonPrimaryUrl"
                        class="btn btn-primary-cta"
                >
                  <span>{{ buttonPrimaryText }}</span>
                </generic-link>
              </template>
              <template v-if="buttonSecondaryExists">
                <generic-link
                        :target="secondaryButtonTarget"
                        :href="buttonSecondaryUrl"
                        class="btn btn-secondary-cta"
                >
                  <span>{{ buttonSecondaryText }}</span>
                </generic-link>
              </template>
            </div>
          </div>
        </template>
        <template v-else-if="buttonSecondaryUrl">
          <generic-link
                  :target="primaryButtonTarget"
                  :href="buttonPrimaryUrl"
                  class="card-overlay-link"
          />
        </template>
      </div>
    </template>
  </div>
</template>
<script>
  import GenericLink from '../../ui-elements/generic-link'
  // import FilestorePresignedURL from '../../filestore-presigned-url'

  export default {
    components: {
      GenericLink
    },
    // mixins: [
    //   FilestorePresignedURL
    // ],
    props: {
      'item': {
        type: Object,
        required: true
      },
      filestore: {
        type: [Object, String],
        required: true
      }
    },
    // data() {
    //   return {
    //     backgroundImageUrl: ''
    //   }
    // },
    // watch: {
    //   item: {
    //     handler: function() {
    //       if (this.item.cardBackgroundUrl) {
    //         this.updateFilestoreImagePaths()
    //       }
    //     },
    //     deep: true
    //   }
    // },
    computed: {
      primaryButtonTarget() {
        if (this.item.cardButtonPrimaryTargetBlank != null &&
          this.item.cardButtonPrimaryTargetBlank) {
          return '_blank'
        }
        else {
          return '_self'
        }
      },
      secondaryButtonTarget() {
        if (this.item.cardButtonSecondaryTargetBlank != null &&
          this.item.cardButtonSecondaryTargetBlank) {
          return '_blank'
        }
        else {
          return '_self'
        }
      },
      type: function() {
        return this.item.cardType
      },
      backgroundColor: function() {
        if (this.item.cardBackgroundColor) {
          return this.item.cardBackgroundColor.rgbaString
        }
        else {
          return 'rgba(255,255,255,1)'
        }
      },
      title: function() {
        return this.item.cardTitle
      },
      description: function() {
        return this.item.cardDescription
      },
      textAlign: function() {
        return this.item.cardTextAlign || 'left'
      },
      verticalTextAlign: function() {
        return this.item.cardVerticalTextAlign || 'bottom'
      },
      textColor: function() {
        if (this.item.cardTextColor) {
          return this.item.cardTextColor.rgbaString
        }
        else {
          return 'rgba(0,0,0,1)'
        }
      },
      buttonPrimaryUrl: function() {
        return this.item.cardButtonPrimaryUrl || ''
      },
      buttonPrimaryText: function() {
        return this.item.cardButtonPrimaryText || ''
      },
      buttonPrimaryExists: function() {
        return (this.buttonPrimaryUrl !== '' && this.buttonPrimaryText !== '')
      },
      buttonSecondaryUrl: function() {
        return this.item.cardButtonSecondaryUrl || ''
      },
      buttonSecondaryText: function() {
        return this.item.cardButtonSecondaryText || ''
      },
      buttonSecondaryExists: function() {
        return (this.buttonSecondaryUrl !== '' && this.buttonSecondaryText !== '')
      },
      backgroundTinting: function() {
        return this.item.cardBackgroundTinting / 100
      },
      videoUrl: function() {
        return this.item.cardVideoUrl || ''
      },
      iconDropShadow: function() {
        return this.item.cardIconDropShadow
      },
      iconPosition: function() {
        return this.item.cardIconPosition
      },
      backgroundImageUrl: function() {
        if (this.item.opmode === 'filestore') {
          return this.$store.getters['filestore/fileCachedImageURL']({
            filepath: this.item.fileStore.filepath,
            preset: this.item.fileStore.preset,
            filestorename: this.filestore.name
          })
        }
        return this.item.cardBackgroundUrl
      }
    },
    // methods: {
    //   updateFilestoreImagePaths() {
    //     this.getPreSignedURL(this.item)
    //       .then(data => {
    //         this.$set(this, 'backgroundImageUrl', data)
    //       })
    //   }
    // },
    created() {
      // this.updateFilestoreImagePaths()
      if (this.item.opmode === 'filestore') {
        this.item.fileStore.filestorename = this.filestore.name
      }
      // this.getPreSignedURL(this.item)
      //   .then(data => {
      //     this.$set(this, 'backgroundImageUrl', data)
      //   })
    }
  }
</script>

<style lang="scss">
:root {
  --main-banner-title-font-weight: 500;
  --main-banner-title-font: var(--main-heading-font);
  --main-banner-title-font-size: 2.6em;
  --main-banner-description-font-size:1em;
  --main-banner-content-width-sm: 85%;
  --main-banner-content-width-md: 70%;
  --main-banner-content-width-lg: 70%;
  --main-banner-content-width-xl: 70%;
}

.animations-disabled {
  .featured-swiper {
    .banner-content-inner {
      opacity:1 !important;
    }
  }
}

</style>
<style lang="scss" scoped>
  @import '~@scss/custom.scss';

  //v.8
  //we're defining some base variable defaults that can be overriden outside of this layout component
  //the overrides must be sourced from a file referenced in this component eg, custom.scss

  //future updates, considerations for more gradient positions

  //swiper core variables
  $swiper-background-color: $secondary !default;
  $swiper-centered-content-padding:4em 0em !default;
  $swiper-image-overlay-tint: $black !default;

  //swiper bullets
  $swiper-bullet-size: 1.1rem !default;
  $swiper-bullet-active-color: $white !default;
  $swiper-bullet-color: $white !default;

  //banner content stuff
  $banner-content-title-weight: 600 !default;
  $banner-content-title: 3em !default;
  $banner-content-description: 1.2em !default;
  $banner-content-gradient-tint-color:$black !default;

  //padding
  $banner-content-padding:2em !default; // multipler of

  //banner buttons
  $banner-button-font-size:1.1em !default;
  $banner-button-border-radius:6px !default;
  $banner-button-primary-background-color: $primary !default;
  $banner-button-primary-text-color: $white !default;

  $banner-button-secondary-background-color: transparent !default;
  $banner-button-secondary-text-color: $white !default;

  //custom swiper styling for hero bannner -----------------------------
  // general styling

  .full-height {
    height: 100%;
    position: relative;
  }
  .featured-swiper {
    width: 100%;
    .swiper-container-horizontal {
      margin: 1rem .25rem;
    }
   ::v-deep .swiper-pagination-bullet {
      height: $swiper-bullet-size;
      width: $swiper-bullet-size;
      cursor: pointer;
      margin:0em .5em;
    }
   ::v-deep .swiper-pagination-bullets {
      bottom: 2rem;
    }
   ::v-deep .swiper-pagination-bullet {
      @include transition (opacity, .3s);
      &:hover {
        background: $white;
        opacity:1;
      }
    }
   ::v-deep .swiper-pagination-bullet,
    .swiper-pagination-bullet-active {
      background: $swiper-bullet-active-color;
    }
  }

 ::v-deep .swiper-slide {
    background-color: $swiper-background-color;
    flex-grow: initial;
    height: auto;
    height:100% !important;
    min-height: var(--swiper-min-height-sm);
    @include media-breakpoint-up(md) {
      min-height: var(--swiper-min-height-md);
    }
    @include media-breakpoint-up(lg) {
      min-height: var(--swiper-min-height-lg);
    }

  }
 ::v-deep .featured-swiper {
    .swiper-arrows{
      position: relative;
      z-index: 9;
    }
    &:hover {
      .swiper-arrow {
        opacity: 1;
      }
      .swiper-pagination {
        @include media-breakpoint-up(lg) {
          opacity:1;
        }
      }
    }
    .swiper-pagination {
      //hide swiper pagination on lg screens and up
      @include media-breakpoint-up(lg) {
        @include transition (opacity, .3s);
        opacity: 0;
      }
    }
    .swiper-arrow {
      //remove swiper arrows on md and down, there's not enough padding on the left and right to clear the content
      @include media-breakpoint-down(md) {
        display: none;
      }
      opacity: 0;
    }

    .swiper-arrow {
      @include transition (transform, .3s);
      &:hover {
        transform: scale(1.3, 1.3);
      }
    }
    .swiper-button-next, .swiper-button-prev {
      z-index:10;
      pointer-events: visible;
      &.swiper-button-disabled {
        cursor: not-allowed;
      }
    }
    .swiper-button-prev {
      left: 1.5em;
    }
    .swiper-button-next {
      right: 1.5em;
    }
  }

  //banner item styling --------------------------------------------------------------
 ::v-deep .banner-item {
    position: relative;
    display: flex;
    flex-direction: column;
    min-width: 0;
    word-wrap: break-word;
    background-clip: border-box;
    height: 100%;
    top:0;

    iframe {
      height: 100%;
    }
  }
  //base banner content styling
 ::v-deep .image-overlay {
    background: $swiper-image-overlay-tint;
    width: 100%;
    height: 100%;
    position: absolute;
    z-index: 1;
  }
 ::v-deep .banner-content {
    flex-direction: column;
    height: 100%;
    z-index: 2;
    display: flex;
    color: $white;
  }
 ::v-deep .banner-title {
    h1 {
      font-size: 2em;
      @include media-breakpoint-up(sm) {
        font-size: 3rem;
      }
    }
  }
 ::v-deep .banner-description {
    font-size: $banner-content-description;
    margin-bottom: 1.5rem;
    @include media-breakpoint-up(sm) {

    }
  }

  //define vertical banner conten positions, bottom, center, top


  .banner-content-position-bottom {
    justify-content: flex-end;
    padding-top:calc(var(--main-banner-padding) * 1.5);
    padding-bottom:calc(var(--main-banner-padding) * 1);
    //margin-top: $banner-content-padding*3;
    @include media-breakpoint-up(md) {
      padding-top:calc(var(--main-banner-padding) * 3);
      padding-bottom:calc(var(--main-banner-padding) * 1);
    }
    @include media-breakpoint-up(lg) {
      padding-top:calc(var(--main-banner-padding) * 4);
      padding-bottom:calc(var(--main-banner-padding) * 1.5);
    }
  }

  .banner-content-position-centered,
  .banner-content-position-center {
    justify-content: center;
    padding-top:calc(var(--main-banner-padding) * 1.5);
    padding-bottom:calc(var(--main-banner-padding) * 1.5);

    @include media-breakpoint-up(md) {
      padding-top:calc(var(--main-banner-padding) * 2);
      padding-bottom:calc(var(--main-banner-padding) * 2);
    }
    @include media-breakpoint-up(lg) {
      padding-top:calc(var(--main-banner-padding) * 3);
      padding-bottom:calc(var(--main-banner-padding) * 3);
    }
  }
  .banner-content-position-top {
    padding-top:calc(var(--main-banner-padding) * 1);
    padding-bottom:calc(var(--main-banner-padding) * 1.5);

    @include media-breakpoint-up(md) {
      padding-top:calc(var(--main-banner-padding) * 1.5);
      padding-bottom:calc(var(--main-banner-padding) * 3);
    }
    @include media-breakpoint-up(lg) {
      padding-top:calc(var(--main-banner-padding) * 1.5);
      padding-bottom:calc(var(--main-banner-padding) * 4);
    }
  }

::v-deep  .absolute-header {
  //for the absolute header, we need to account for height of the main site header that has been absolutely positioned over the content
  //don't use margin for this even though it would make this easier to read

  .header-carousel, .main-banner {
    .banner-content-position-bottom {
      justify-content: flex-end;
      padding-top: calc(var(--main-banner-padding) * 1.5 + var(--main-site-header-height));

      @include media-breakpoint-up(md) {
        padding-top: calc(var(--main-banner-padding) * 3 + var(--main-site-header-height));
      }

      @include media-breakpoint-up(lg) {
        padding-top: calc(var(--main-banner-padding) * 4 + var(--main-site-header-height));
      }
    }

    .banner-content-position-centered,
    .banner-content-position-center {
      justify-content: center;
      padding-top: calc(var(--main-banner-padding) * 1.5 + var(--main-site-header-height));

      @include media-breakpoint-up(md) {
        padding-top: calc(var(--main-banner-padding) * 2 + var(--main-site-header-height));
      }

      @include media-breakpoint-up(lg) {
        padding-top: calc(var(--main-banner-padding) * 3 + var(--main-site-header-height));
      }
    }

    .banner-content-position-top {
      padding-top: calc(var(--main-banner-padding) * 1 + var(--main-site-header-height));

      @include media-breakpoint-up(md) {
        padding-top: calc(var(--main-banner-padding) * 1.5 + var(--main-site-header-height));
      }

      @include media-breakpoint-up(lg) {
        padding-top: calc(var(--main-banner-padding) * 1.5 + var(--main-site-header-height));
      }
    }
  }

}

  //define horizontal banner content text positions on ~tablet and up

  @include media-breakpoint-up(sm) {
    .banner-text-left {
      text-align: left;
      .banner-action {
        .btn {
          margin-right: 1em;
        }
      }
    }
    .banner-text-right {
      text-align: right;
      .row {
        justify-content: flex-end;
      }
      .banner-action {
        .btn {
          margin-left: 1em;
        }
      }
    }
    .banner-text-centered,
    .banner-text-center {
      text-align: center;
      .row {
        justify-content: center;
      }
      .banner-action {
        .btn {
          margin: 0em .5em;
        }
      }
    }
    .banner-text-justify {
      text-align: justify;
      .row {
        justify-content: center;
      }
    }
  }
  //we center banner content regardless of the above settings on sm and below sizes
  .banner-content {
    top:0;
    position: relative;
    @include media-breakpoint-down(sm) {
      text-align: center;
    }
  }

  //when banner content positiong is top, include veritcal gradient, top down, tinted to transparent
  .banner-content-position-top {
    &.banner-content-gradient {
      @include gradient-y($start-color: rgba($banner-content-gradient-tint-color, 0.6), $end-color:rgba($banner-content-gradient-tint-color, 0), $start-percent: 0%, $end-percent: 90%);
    }
  }
  //in any other case, include veritcal gradient, starting from the bottom, tinted to transparent
  .banner-content-gradient {
    @include gradient-y($start-color: rgba($banner-content-gradient-tint-color, 0), $end-color:rgba($banner-content-gradient-tint-color, 0.6), $start-percent: 10%, $end-percent: 100%);
  }

  //common image background structure, may be moved to common
  .color-background {
    height: 100%;
    width: 100%;
    position: absolute;
    z-index: 1;
  }

  .image-background {
    height: 100%;
    width: 100%;
    position: absolute;
    background-size: cover;
    ::v-deep .a-image {
      background: var(--main-image-background-color);
      img {
        object-position: var(--main-banner-background-position);
      }
    }
  }

  //assumes only one banner link
  .banner-overlay-link {
    width: 100%;
    height: 100%;
    position: absolute;
  }

  .banner-action {
    .banner-btn {
      font-size:$banner-button-font-size;
      border:0px;
      padding: 1.2rem 2.5rem;
      outline: none;

      //override bootstrap btn default
      white-space: normal;
      margin-bottom: 1rem;
    }
  }
  //custom themeing
  .card-type-photo {
    //banner button styling

    .banner-btn-primary{
      //background-color: $banner-button-primary-background-color;
      //color: $banner-button-primary-text-color;
      @include transition (background-color, .3s);
      @include hover-focus {
        ///background-color: darken($banner-button-primary-background-color, 5%);
      }
    }
    /*     .banner-btn-secondary{
          background-color: $banner-button-secondary-background-color;
          color: $banner-button-secondary-text-color;
          box-shadow:inset 0 0 0px 2px rgba($banner-button-secondary-text-color, .5);
          @include transition (background-color, .3s);
          @include hover-focus {
            background-color: darken($banner-button-secondary-background-color, 10%);
            box-shadow:inset 0 0 0px 2px $banner-button-secondary-text-color;

          }
        } */

  }
  //photo card
  .card-type-color {
    .banner-btn {
      color:$white;
    }
    .banner-btn-primary {
      //color inline from content creator widget
      background-color:rgba($black, 0.5);
      @if $enable-rounded {
        border-radius: $border-radius-sm;
      }
      @include hover-focus {
        background-color:rgba($black, 0.75);
        outline:none;
      }
    }
    .banner-btn-secondary {
      //color inline from content creator widget
      background-color:rgba($black, 0.2);
      @if $enable-rounded {
        border-radius: $border-radius-sm;
      }
      @include hover-focus {
        background-color:rgba($black, 0.5);
        outline:none;
      }
    }
  }


//featured swiper animations

.featured-swiper {
  .banner-content-inner {
    opacity:0;
    @include transition (opacity .3s ease-in-out);
  }
  .swiper-slide-active {

    .banner-content-inner {
      animation: fadeInUp .4s ease-in-out .5s forwards;
    }
  }
}

//fadeInUp animation for main banner content inner text when slide is active

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(1em);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.main-banner-section {
  position: relative;

  .banner-item {
    //variables created to give external control over the widths of the banner items, max width
    .col {
      @include media-breakpoint-down(sm) {
      margin:0 auto;
      }
      max-width: var(--main-banner-content-width-sm);
      @include media-breakpoint-up(md) {
      max-width: var(--main-banner-content-width-md);
      }
      @include media-breakpoint-up(lg) {
        max-width: var(--main-banner-content-width-lg);
      }
      @include media-breakpoint-up(xl) {
        max-width: var(--main-banner-content-width-xl);
      }
    }
    .banner-content {
      .banner-description {
        font-size: var(--main-banner-description-font-size);

        @include media-breakpoint-up(md) {
          font-size: calc(var(--main-banner-description-font-size)*1.1);
        }

        @include media-breakpoint-up(lg) {
          font-size: calc(var(--main-banner-description-font-size)*1.25);
        }
      }

      .banner-title {
        h1 {
          font-family: var(--main-banner-title-font);
          font-weight: var(--main-banner-title-font-weight);
          font-size: var(--main-banner-title-font-size);
          @include media-breakpoint-up(md) {
            font-size: calc(var(--main-banner-title-font-size)*1.25);
          }
          @include media-breakpoint-up(lg) {
            font-size: calc(var(--main-banner-title-font-size)*1.5);
          }
        }
      }
    }

  }
}

</style>
